import { _ as a } from "../internals/export.js";
import { g as r } from "../internals/global.js";
import { m as e } from "../internals/microtask.js";
import { a as n } from "../internals/a-callable.js";
import { v as s } from "../internals/validate-arguments-length.js";
import { e as t } from "../internals/engine-is-node.js";
var o = r.process;
a({
  global: !0,
  enumerable: !0,
  dontCallGetSet: !0
}, {
  queueMicrotask: function queueMicrotask(a) {
    s(arguments.length, 1), n(a);
    var r = t && o.domain;
    e(r ? r.bind(a) : a);
  }
});